<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-25 16:15:49
 * @FilePath: \gcp-fe\src\app\shop\views\shopping.vue
 * @Description: 首页
-->
<template>
  <div>
    <div class="wrapper">
      <div class="yindaotu" v-if="dialogVisible">
        <div>
          <div class="img1 img" v-if="img1">
            <img src="@/basa/assets/yindao/1.png" alt="" />
            <div class="yindaoclose" @click="closeY"></div>
            <div class="xiayibu" @click="xiayibu('img2')"></div>
          </div>
          <div class="img2 img" v-if="img2">
            <img src="@/basa/assets/yindao/2.png" alt="" />
            <div class="yindaoclose" @click="closeY"></div>
            <div class="xiayibu" @click="xiayibu('img3')"></div>
          </div>
          <div class="img3 img" v-if="img3">
            <img src="@/basa/assets/yindao/3.png" alt="" />
            <div class="yindaoclose" @click="closeY"></div>
            <div class="xiayibu" @click="xiayibu('img4')"></div>
          </div>
          <div class="img4 img" v-if="img4">
            <img src="@/basa/assets/yindao/4.png" alt="" />
            <div class="yindaoclose" @click="closeY"></div>
            <div class="xiayibu" @click="xiayibu('img5')"></div>
          </div>
          <div class="img5 img" v-if="img5">
            <img src="@/basa/assets/yindao/5.png" alt="" />
            <div class="yindaoclose" @click="closeY"></div>
            <div class="xiayibu" @click="xiayibu('img6')"></div>
          </div>
          <div class="img6 img" v-if="img6">
            <img src="@/basa/assets/yindao/6.png" alt="" />
            <div class="yindaoclose" @click="closeY"></div>
            <div class="xiayibu" @click="xiayibu('img7')"></div>
          </div>
          <div class="img7 img" v-if="img7">
            <img src="@/basa/assets/yindao/7.png" alt="" />
            <div class="yindaoclose" @click="closeY"></div>
            <div class="xiayibu" @click="xiayibu('img8')"></div>
          </div>
          <div class="img8 img" v-if="img8">
            <img src="@/basa/assets/yindao/8.png" alt="" />
            <div class="yindaoclose" @click="closeY"></div>
            <div class="xiayibu" @click="closeY"></div>
          </div>
        </div>
      </div>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        class="yindao"
      >
        <span>这是一段信息</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <div class="ccui-clearfix pt10">
        <!--类别-->
        <!-- <catalog></catalog> -->
        <!--轮播图-->
        <slideShow :imgData="imgOptionsA"></slideShow>
        <!--用户登录信息-->
        <showUser :imgData="imgOptionsB"></showUser>
      </div>

      <!-- 商城直采 -->
      <!-- <noticeList1
      v-for="item in workDynamicsList1"
      :key="item.type"
      :workDynamicsList="item"
    ></noticeList1> -->
      <!-- 资源共享 -->
      <!-- <noticeList2
      v-for="item in workDynamicsList2"
      :key="item.type"
      :workDynamicsList="item"
    >
    </noticeList2> -->

      <!-- 暂时不上 -->
      <!-- <div class="top" ref="top">
      <div class="shop-car top-public checkType" ref="firstElement">
        <a :href="empUrl" target="_self">
          <span class="ccuifont icon-ccui-cart-o">
            <i class="ci-count">{{ catNums }}</i> </span
          >购物车
          <span class="top-public-line"></span>
        </a>
      </div>
      <div class="requirement top-public" @click="faxuqiu">
        <span class="xuqiu"></span>
        发布需求
        <span class="top-public-line"></span>
      </div>
      <div class="customer top-public" @click="kefu">
        <span class="ccuifont icon-ccui-kefu"></span>客服
        <span class="top-public-line"></span>
      </div>
      <div class="feedback top-public" @click="fankui">
        <span class="ccuifont icon-ccui-fankui"></span>反馈
        <span class="top-public-line"></span>
      </div>
      <div class="to-top top-public" @click="toTop">
        <span class="ccuifont icon-ccui-next"></span>顶部
      </div>
    </div> -->
    </div>
    <!-- 政策法规和通知公告 -->
    <div class="lawAndNotice mb20">
      <!-- 政策法规 -->
      <notice-list
        :workDynamicsList="lawDynamicsList"
        :type="'lawType'"
      ></notice-list>
      <div class="jg20"></div>
      <!-- 通知公告 -->
      <notice-list
        :workDynamicsList="workDynamicsList"
        :type="'noticeType'"
      ></notice-list>
    </div>
    <div class="wrapper">
      <!-- 最新采购公告 -->
      <noticeListNew></noticeListNew>
    </div>
    <div style="height: 301px;background: #fff;">
      <!-- 专区入口 -->
      <zoneEntrance></zoneEntrance>
    </div>
    <valueAddedService></valueAddedService>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import slideShow from "@/app/shop/components/slideShow.vue";
import showUser from "@/app/shop/components/showUser.vue";
import noticeList from "@/app/shop/components/noticeList.vue";
// import noticeList1 from "@/app/shop/components/noticeList1.vue";
// import noticeList2 from "@/app/shop/components/noticeList2.vue";
import noticeListNew from "@/app/shop/components/noticeListNew.vue";
import zoneEntrance from "@/app/shop/components/zoneEntrance.vue";
import valueAddedService from "@/app/shop/components/valueAddedService.vue";
import { addUrlPerFix } from "@/basa/utils";
import {
  // qryNoticePageList,
  // cartNum,
  qryAdvInfoList,
  qrySubTypeInfoList,
  qryNoticeInfoPageList
  // showFlag
} from "@/app/shop/api/shopping";
import { COMM_TYPE_MAPPING } from "@/config/const/comm";
export default {
  name: "shopping",
  components: {
    slideShow,
    showUser,
    noticeList,
    // noticeList1,
    // noticeList2,
    noticeListNew,
    zoneEntrance,
    valueAddedService
  },
  data() {
    return {
      img1: true,
      img2: false,
      img3: false,
      img4: false,
      img5: false,
      img6: false,
      img7: false,
      img8: false,
      dialogVisible: false,
      imgOptionsA: [],
      imgOptionsB: [],
      lawDynamicsList: {
        label: this.$t("noticeList.noticeTitle"), // 政策法规
        labelItem: this.$t("noticeList.noticeTitleItem"), // 法法规
        list: []
      },
      workDynamicsList: {
        label: this.$t("noticeList.noticeTitle1"), // 通知公告
        labelItem: this.$t("noticeList.noticeTitleItem1"), // 公告
        list: []
      },
      newDynamicsList: {
        label: this.$t("noticeList.newDynamicsList.label"), // 最新通知公告
        list: [
          {
            label: this.$t("noticeList.newDynamicsList.labelAll"), // 全部
            list: []
          },
          {
            label: this.$t("noticeList.newDynamicsList.labelItem1"), // 牵源
            list: []
          },
          {
            label: this.$t("noticeList.newDynamicsList.labelItem2"), // 设备
            list: []
          },
          {
            label: this.$t("noticeList.newDynamicsList.labelItem3"), // 工程分包
            list: []
          },
          {
            label: this.$t("noticeList.newDynamicsList.labelItem4"), // 工程服务
            list: []
          },
          {
            label: this.$t("noticeList.newDynamicsList.labelItem5"), // 其它服务
            list: []
          }
        ]
      },
      workDynamicsList1: [],
      workDynamicsList2: [],
      empUrl: `${addUrlPerFix(process.env.VUE_APP_EMC_URL)}/index`,
      catNums: 0, // 购物车数量
      screenWidth: document.body.clientWidth,
      timer: false
    };
  },
  created() {
    // if (Cookies.get("access_token")) {
    //   this.img1 = false;
    //   this.img2 = true;
    // }
    this.img1 = false;
    this.img6 = true;
  },
  watch: {
    // 监听屏幕宽度 改变悬浮框样式
    // screenWidth(val) {
    //   if (!this.timer) {
    //     const element = this.$refs.top;
    //     if (val < 1380) {
    //       element.classList.remove("top-right"); // 移除
    //       element.classList.add("top-left");
    //     } else if (val > 1380) {
    //       element.classList.remove("top-left"); // 移除
    //       element.classList.add("top-right");
    //     }
    //     this.timer = true;
    //     const that = this;
    //     setTimeout(() => {
    //       that.timer = false;
    //     }, 400);
    //   }
    // }
  },
  activated() {
    //if (!localStorage.getItem("yijinlai1")) {
    //this.dialogVisible = true;
    //}
    this.init();
  },
  mounted() {
    // 监听屏幕宽度 改变悬浮框样式
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
    // this.init();
  },
  methods: {
    init() {
      // setTimeout(() => {
      //   const element = this.$refs.top;
      //   element.classList.remove("top-right"); // 移除
      //   element.classList.remove("top-left"); // 移除
      //   // 监听屏幕宽度 改变悬浮框样式
      //   const that = this;
      //   window.onresize = () => {
      //     return (() => {
      //       window.screenWidth = document.body.clientWidth;
      //       that.screenWidth = window.screenWidth;
      //     })();
      //   };
      // }, 1000);
      // 查询宣传海报
      // queryLscpPortalList({
      //   columnType: 1,
      //   isShowPageLoading: true
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.imgOptionsA = res.data.data;
      //     // this.imgOptionsB =
      //     //   res.data.data.qryPostersListRspListBO[1].publicityContentBOS;
      //   }
      // });
      this.getIndexBanner();
      this.getNoticeInfoPageList();

      // 商城直采
      // queryLscpPortalList({
      //   columnType: 2,
      //   isShowPageLoading: true
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     if (res.data.data.length) {
      //       this.workDynamicsList1.list = res.data.data;
      //     }
      //   }
      // });
      this.getMallPurchase();

      // 资源共享
      // queryLscpPortalList({
      //   columnType: 3,
      //   isShowPageLoading: true
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     if (res.data.data.length) {
      //       this.workDynamicsList2.list = res.data.data;
      //     }
      //   }
      // });
      this.getResourceSharing();

      // 悬浮框  购物车数量
      // if (JSON.parse(localStorage.getItem("userInfo"))?.openId) {
      //   cartNum({
      //     openId: JSON.parse(localStorage.getItem("userInfo")).openId
      //   }).then(res => {
      //     if (res.data.code === "0") {
      //       this.catNums = res.data.data;
      //     }
      //   });
      // } else {
      //   this.catNums = 0;
      // }
    },

    async getNoticeInfoPageList() {
      const res = await qryNoticeInfoPageList({
        pageNum: 1,
        pageSize: 5,
        status: 2,
        type: COMM_TYPE_MAPPING.INDEX_NOTICES,
        languageFlag: Cookies.get("language")
      });
      // 通知公告
      this.workDynamicsList.list = res.data.data.rows;

      const res0 = await qryNoticeInfoPageList({
        pageNum: 1,
        pageSize: 5,
        status: 2,
        type: COMM_TYPE_MAPPING.LAWS_AND_REGULATIONS,
        languageFlag: Cookies.get("language")
      });
      // 政策法规
      this.lawDynamicsList.list = res0.data.data.rows;
    },

    xiayibu(a) {
      if (a == "img3") {
        window.scrollTo({
          top: 300,
          behavior: "smooth"
        });
      } else if (a == "img4") {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (a == "img5") {
        window.scrollTo({
          top: 500,
          behavior: "smooth"
        });
      } else if (a == "img6") {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
      if (a == "img2") {
        this.img2 = true;
        this.img1 = false;
      } else if (a == "img3") {
        this.img3 = true;
        this.img2 = false;
      } else if (a == "img4") {
        this.img4 = true;
        this.img3 = false;
      } else if (a == "img5") {
        this.img5 = true;
        this.img4 = false;
      } else if (a == "img6") {
        this.img6 = true;
        this.img5 = false;
      } else if (a == "img7") {
        this.img7 = true;
        this.img6 = false;
      } else if (a == "img8") {
        this.img8 = true;
        this.img7 = false;
      } else if (a == "close") {
        this.dialogVisible = false;
      }
    },
    closeY() {
      this.dialogVisible = false;
      localStorage.setItem("yijinlai1", true);
    },
    // 发需求
    faxuqiu() {
      // window.location.href = `${addUrlPerFix(
      //   process.env.VUE_APP_MOA_URL
      // )}/requirement-publishing/new-demand?a=100112`;
      if (this.$store.getters.getLoginInfo.name) {
        // showFlag({ agentId: "100013" }).then(res => {
        //   if (res.data.data == true) {
        //     window.location.href = `${addUrlPerFix(
        //       process.env.VUE_APP_MOA_URL
        //     )}/requirement-publishing/new-demand?a=100021`;
        //   } else if (res.data.data == false) {
        //     this.$confirm("该功能仅为采购组织用户提供！", "提示", {
        //       dangerouslyUseHTMLString: true,
        //       showCancelButton: false,
        //       customClass: "message-box-faxuqiu",
        //       message:
        //         '<div style="font-size: 16px;">该功能仅为采购组织用户提供！</div>'
        //     });
        //   }
        // });
        // 去掉弹框提示
        window.location.href = `${addUrlPerFix(
          process.env.VUE_APP_MOA_URL
        )}/requirement-publishing/new-demand?a=100021`;
      } else {
        // window.location.href = `${addUrlPerFix(
        //     process.env.VUE_APP_MOA_URL
        //   )}/requirement-publishing/new-demand?a=100021`;
        // }
        window.location.href =
          this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
          "?redirectUrl=" +
          encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_BASE_URL));
      }
    },
    // 客服  https://work.weixin.qq.com/kfid/kfca8000d191a60882f
    kefu() {
      const zx = document.querySelector(".app-item.zaixian");
      zx && zx.click();
    },
    // 反馈
    fankui() {
      window.location.href = `${addUrlPerFix(
        process.env.VUE_APP_MOA_URL
      )}/user-feedback/user-feedback-list/list?a=100112`;
    },
    // 返回顶部
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    // 查询宣传海报
    async getIndexBanner() {
      const res = await qryAdvInfoList({
        type: COMM_TYPE_MAPPING.INDEX_BANNER,
        status: 2,
        languageFlag: Cookies.get("language"),
        isShowPageLoading: true
      });
      this.imgOptionsA = res.data.data;
    },
    // 商城直采
    async getMallPurchase() {
      const res = await qrySubTypeInfoList({
        parentType: COMM_TYPE_MAPPING.INDEX_MALL_PURCHASE,
        languageFlag: Cookies.get("language"),
        isShowPageLoading: false
      });
      const channelList = res.data.data.cmsTypeInfoBOList.map(item => {
        return {
          id: item.type,
          label: item.typeName,
          list: []
        };
      });
      channelList.forEach(async item => {
        const res = await qryAdvInfoList({
          type: item.id,
          status: 2,
          languageFlag: Cookies.get("language"),
          isShowPageLoading: false
        });
        item.list = res.data.data;
      });
      this.workDynamicsList1 = channelList;
    },
    // 资源共享
    async getResourceSharing() {
      const res = await qrySubTypeInfoList({
        parentType: COMM_TYPE_MAPPING.INDEX_RESOURCE_SHARING,
        languageFlag: Cookies.get("language"),
        isShowPageLoading: true
      });
      const channelList = res.data.data.cmsTypeInfoBOList.map(item => {
        return {
          id: item.type,
          label: item.typeName,
          img: "",
          left: null,
          list: []
        };
      });
      channelList.forEach(async item => {
        const res = await qryAdvInfoList({
          type: item.id,
          status: 2,
          languageFlag: Cookies.get("language"),
          isShowPageLoading: true
        });
        const areaA = res.data.data.filter(item => item.area === 1);
        const areaB = res.data.data.filter(item => item.area === 2);
        if (areaA.length > 0) {
          item.img = areaA[0].imgUrl;
          item.left = areaA[0];
        }
        item.list = areaB;
      });
      // console.log(channelList, "aaaaa");
      this.workDynamicsList2 = channelList;
    }
  }
};
</script>
<style>
.message-box-faxuqiu .el-button--primary span {
  font-size: 15px;
}

.message-box-faxuqiu .el-message-box__header .el-message-box__title span {
  font-size: 16px;
}
</style>
<style lang="scss" scoped>
.pt10 {
  padding-top: 10px;
}

.lawAndNotice {
  text-align: center;
  background: #fff;
  height: 314px;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  // padding-bottom: 20px;

  .jg20 {
    margin: 0 10px;
  }
}

.mb20 {
  margin-bottom: 20px;
}

.top {
  position: fixed;
  left: 50%;
  top: 40%;
  margin-left: 610px;
  width: 61px;
  /*height: 372px;*/
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.09);

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #4a4a4a;
  line-height: 18px;
  text-align: left;
  font-style: normal;
}

.top-left {
  left: auto !important;
  right: 10px !important;
  z-index: 100 !important;
}

.top-right {
  left: 50% !important;
  right: auto !important;
  z-index: 100 !important;
}

.top .ccuifont {
  display: block;
  font-size: 17px;
  margin: 0 auto 4px;
}

.top .top-public {
  cursor: pointer;
  width: 61px;
  height: 62px;
  margin: 0 auto;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4a4a4a;
  text-align: center;
  position: relative;
}

.top .top-public .top-public-line {
  position: absolute;
  bottom: -1px;
  left: 20%;
  display: block;
  width: 39px;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(227, 227, 227, 1) 51%,
    rgba(255, 255, 255, 1) 100%
  );
}

.top .top-public .ccuifont {
  padding-top: 11px;
}

.top .top-public:hover {
  background: #0089ef;
  color: #ffffff;
}

.top .top-public:hover .ccuifont {
  color: #fff;
}

.top .top-public a {
  color: #4a4a4a;
}

.top .top-public:hover a {
  color: #fff;
}

.top .top-public .ccuifont .ci-count {
  position: absolute;
  height: 10px;
  top: 10px;
  left: 31px;
  right: auto;
  display: inline-block;
  padding: 1px 3px;
  font-size: 12px;
  line-height: 12px;
  color: #fff;
  background-color: #ff142f;
  border-radius: 7px;
  min-width: 10px;
  text-align: center;
  font-style: normal;
}

.top .top-public:hover .ccuifont .ci-count {
  background-color: #fff;
  color: #0089ef;
}

// .top .checkType {
//   background: #0089ef;
//   color: #ffffff;
//   a {
//     color: #ffffff;
//     .ccuifont .ci-count {
//       background-color: #fff;
//       color: #0089ef;
//     }
//   }
// }

.top .to-top {
  color: #0089ef;
}

.top .icon-ccui-next {
  transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  /* IE 9 */
  -moz-transform: rotate(270deg);
  /* Firefox */
  -webkit-transform: rotate(270deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(270deg);
  /* Opera */
  padding-top: 0 !important;
  padding-right: 11px !important;
  margin-bottom: 9px !important;
}

.top .requirement {
  box-sizing: border-box;
  padding-top: 13px;
}

// .top .checkType a span {
//   display: block;
//   margin: 0 auto;
//   width: 18px;
//   height: 18px;
//   background-image: url("../img/car1.png");
//   background-repeat: no-repeat;
//   background-position: center;
// }
.top .requirement span {
  display: block;
  margin: 0 auto 4px;
  width: 18px;
  height: 18px;
  background-image: url("../img/icon_fabu2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.top .requirement:hover span {
  background-image: url("../img/icon_fabu1.png");
}

// 客服
.top .customer span {
  display: block;
  margin: 0 auto;
  width: 18px;
  height: 18px;
  background-image: url("../img/zaixian.png");
  background-repeat: no-repeat;
  background-position: center;
}

.top .customer:hover span {
  background-image: url("../img/zaixian1.png");
}

// 反馈
.top .feedback span {
  display: block;
  margin: 0 auto;
  width: 18px;
  height: 18px;
  background-image: url("../img/feedback.png");
  background-repeat: no-repeat;
  background-position: center;
}

.top .feedback:hover span {
  background-image: url("../img/feedback1.png");
}

.icon-ccui-next:before {
  content: "\e684";
}

/deep/.yindao {
  .el-dialog {
    display: none;
  }
}

.yindaotu {
  .img {
    z-index: 20000000;
    position: absolute;

    .yindaoclose {
      position: absolute;
      width: 35px;
      height: 35px;
    }

    .xiayibu {
      position: absolute;
      width: 130px;
      height: 50px;
    }
  }

  .img1 {
    right: 12px;
    top: 112px;

    .yindaoclose {
      left: 0;
      top: 10px;
    }

    .xiayibu {
      right: 135px;
      bottom: 12px;
    }
  }

  .img2 {
    left: 46px;
    top: -41px;

    .yindaoclose {
      right: 0;
      top: 31px;
    }

    .xiayibu {
      left: 85px;
      bottom: 12px;
    }
  }

  .img3 {
    top: 405px;
    right: 1px;

    .yindaoclose {
      left: 0;
      top: 10px;
    }

    .xiayibu {
      right: 115px;
      bottom: 12px;
    }
  }

  .img4 {
    top: -126px;
    left: 53px;

    .yindaoclose {
      left: 0;
      top: 60px;
    }

    .xiayibu {
      right: 345px;
      bottom: 12px;
    }
  }

  .img5 {
    top: 452px;

    .yindaoclose {
      right: 0px;
      top: 116px;
    }

    .xiayibu {
      left: 365px;
      bottom: 16px;
    }
  }

  .img6 {
    // top: -189px;
    // right: 78px;
    top: -331px;
    right: 75px;

    .yindaoclose {
      left: 0px;
      top: 55px;
    }

    .xiayibu {
      left: 388px;
      bottom: 16px;
    }
  }

  .img7 {
    // top: -188px;
    // right: 78px;
    top: -331px;
    right: 75px;

    .yindaoclose {
      left: 0px;
      top: 50px;
    }

    .xiayibu {
      left: 388px;
      bottom: 16px;
    }
  }

  @media screen and (min-width: 1281px) {
    .img6 {
      // top: -189px;
      // right: 63px;
      top: -331px;
      right: 75px;
    }

    .img7 {
      // top: -188px;
      // right: 63px;
      top: -331px;
      right: 75px;
    }
  }

  .img8 {
    top: -60px;
    left: 196px;
    // top: -40px;
    // left: 138px;

    .yindaoclose {
      right: 0;
      top: 40px;
      // right: 0;
      // top: 15px;
    }

    .xiayibu {
      left: 130px;
      bottom: 13px;
      // left: 88px;
      // bottom: 16px;
    }
  }
}

.wrapper {
  position: relative;
}
</style>
